<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as CONTACT_QUALIFICATION } from './store'
import CommonFiltersMixin from '../../../common-filters/CommonFiltersMixin'

export default {
  name: 'ContactQualificationCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: CONTACT_QUALIFICATION.GENERIC.organization.contactqualification.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...CONTACT_QUALIFICATION.GENERIC.organization.contactqualification.LIST.ACTIONS
    })
  }
}
</script>
